import { message } from "antd";
import axios from "axios";
import { apiHeaders } from "../../helper/apiHeader";
import { getStudentData } from "../../helper/localStorage";

export const getSurveyQue = (surveyId, dispatchSurvey) => {

  const myData = {
    data: {
      player_id: getStudentData().login_id,
      survey_id: surveyId,
      player_name: getStudentData().data.master[0].firstname,
    },
  };

  dispatchSurvey({ type: "SURVEY_LOADER" })
  axios
    .post("/MetaData", myData, apiHeaders("getsurveyque"))
    .then((res) => {
      if (res.data.status === "201") {
        dispatchSurvey({ type: "SURVEY_QUES", payload: res.data.data })
      }
      else if (res.data.status === "406") {
        dispatchSurvey({ type: "ANSWERED_QUES", payload: res.data.data })
      }
      else {
        message.error(res.data.msg)
        dispatchSurvey({ type: "SURVEY_ERR" })
      }
    })
    .catch(() => {
      message.error("Please wait for sometime or check your internet connection. Try again")
      dispatchSurvey({ type: "SURVEY_ERR" })
    });
};
